import { AddToCartErrorType } from '../../../../types/errors';
import settingsParams from '../../settingsParams';
import { CreateActionParams } from '../actions';

export type OnClickViewCart = () => Promise<void>;

export function createOnClickViewCartAction({ context }: CreateActionParams) {
  return async () => {
    const { wixSdkAdapter } = context;
    await wixSdkAdapter.navigateToEcomCart();
  };
}

export type OnClickContinueBrowsing = () => Promise<void>;

export function createOnClickContinueBrowsingAction({
  context,
}: CreateActionParams) {
  return async () => {
    const { wixSdkAdapter, settings } = context;
    const continueShoppingLink = settings.get(
      settingsParams.cartPopupWhereToLinkContinueBrowsing,
    );
    await wixSdkAdapter.navigateToContinueShopping(continueShoppingLink);
  };
}

export type OnClickCloseCartErrorModal = () => void;

export function createOnClickCloseCartErrorModalAction({
  internalActions,
}: CreateActionParams) {
  return () => {
    internalActions.errorHandlers.clearErrorByTypes([AddToCartErrorType]);
  };
}
